import React from 'react';
import SEO from '../components/SEO';
import Details from '../components/Details';

const Contact = () => {
  return (
    <>
      <SEO
        title="Contact Perumal Crane Services | 24/7 Crane Rental Support Coimbatore"
        description="Contact Perumal Crane Services for crane rental inquiries in Coimbatore. Available 24/7 for emergency crane services. Call +91 76395 68608 or chat on WhatsApp for instant quotes and support."
        keywords="contact crane service Coimbatore, crane rental inquiry, emergency crane service, 24/7 crane support, Perumal Crane Services contact, WhatsApp crane booking, crane rental quote Coimbatore"
        canonicalUrl="/contact"
        ogTitle="Contact Perumal Crane Services - 24/7 Support Available"
        ogDescription="Get in touch with Coimbatore's leading crane rental service. Instant quotes, emergency support, and professional assistance available 24/7."
      />
      <Details />
    </>
  );
};

export default Contact;